import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { SelectInput } from "../../../../common/form";
import paymentTypes from "../../enums/paymentTypes";

const ClientPayment = ({ disabled }) => (
  <div className="ClientSubsection">
    <div className="ClientPaymentSubsection">
      <h3>
        <FormattedMessage id="clients.form.payment.title" />
      </h3>
      <Field
        id="paymentType"
        name="paymentType"
        component={SelectInput}
        options={paymentTypes}
        addBlankOption={true}
        label={<FormattedMessage id="clients.form.client.paymentmode" />}
        disabled={disabled}
      />
    </div>
  </div>
);

ClientPayment.propTypes = {
  disabled: PropTypes.bool,
};

export default ClientPayment;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientPayment.js